import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface ItineraryFormProps {
  content: string;
  onChange: (content: string) => void;
}

export function ItineraryForm({ content, onChange }: ItineraryFormProps) {
  return (
    <div className="space-y-2">
      
      <Textarea
        className="min-h-[300px] font-mono"
        placeholder="Enter the itinerary details here. You can use markdown formatting:

# Tour Itinerary

**Morning Activities:**
- 09:00 - Start from hotel
- 10:00 - First destination
- 12:00 - Lunch break

**Afternoon Activities:**
- 14:00 - Second destination
- 16:00 - Final destination
- 17:00 - Return to hotel

**What's Included:**
- Transportation
- Entrance fees
- Guide service

**Additional Notes:**
Any other important information"
        value={content}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="text-sm text-muted-foreground space-y-1">
        <p>Text Formatting Guide:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong>Bold:</strong> **text** or __text__</li>
          <li><em>Italic:</em> *text* or _text_</li>
          <li><u>Underline:</u> &lt;u&gt;text&lt;/u&gt;</li>
        </ul>
      </div>
    </div>
  );
}
